<template>
  <template v-if="state.show === 'desktop'">
    <Desktop
      :cart="cart"
      :products="products"
      :fees="fees"
    ></Desktop>
  </template>
  <template v-else-if="state.show === 'mobile'">
    <Mobile
      :cart="cart"
      :products="products"
      :fees="fees"
    ></Mobile>
  </template>
</template>

<script setup>
import flatten from '@/helpers/flatten';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import { computed, onMounted, onUnmounted, reactive } from 'vue';
import Desktop from './Desktop/Cart.vue';
import Mobile from './Mobile/Cart.vue';

const props = defineProps({
  cart: {
    type: Object,
    required: false,
  }
});

const state = reactive({
  show: null,
});

let media;

function extract(type) {
  let lines = props.cart?.lines ?? [];

  lines = filter(lines, { type });
  lines = groupBy(lines, line => line.name);
  lines = flatten(lines);

  return lines;
}

const fees = computed(() => [
  ...extract('shipping'),
  ...extract('surcharge'),
]);

const products = computed(() =>
  extract('product')
);

function handler() {
  state.show = media.matches ? 'desktop' : 'mobile';
}

onMounted(() => {
  media = window.matchMedia('(min-width: 1024px)');
  window.addEventListener('resize', handler);
  handler();
});

onUnmounted(() => {
  window.removeEventListener('resize', handler);
});

</script>
